import { render, staticRenderFns } from "./ApiBatchView.vue?vue&type=template&id=40cb7c48&"
import script from "./ApiBatchView.vue?vue&type=script&lang=js&"
export * from "./ApiBatchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports